import React from "react";

export default class EBPopup extends React.Component {
  render() {
    return (
      <div
        id="divDialog"
        class="dialog boxshadow"
        style={{ overflowY: "auto" }}
      >
        <div class="dialog_content" style={{ overflowY: "auto" }}>
          <p align="justify">
            National Remote Sensing Centre (NRSC) is one of the implementing
            agencies under National Hydrology Project (NHP). Under NHP, NRSC is
            establishing evaporative flux monitoring system for entire India.
            Under this project, it is proposed to estimate evaporative flux with
            space-based input along with meteorological data. Towards
            development of evaporative flux monitoring system for Indian region
            NRSC has developed procedure for daily evaporative flux estimation
            based on satellite remote sensing data at an appropriate spatial
            scale.
          </p>{" "}
          <p align="justify">
            Evapotranspiration (ET) is the process by which the water gets
            transported from soil and/or the vegetation to the atmosphere. In
            this process the energy also gets transported from land to
            atmosphere. The main drivers for this process are i) solar
            radiation, ii) vapour pressure gradient between the evaporating
            surface and the atmosphere and iii) the resistance that the land
            cover offers to the process. ET can be determined by direct
            measurement or estimated through hydro meteorological parameters.
            Beside direct methods, there were many empirical and analytical
            methods are developed to calculate ET from the meteorological data
            and energy fluxes.
          </p>
          <p align="justify">
            Analytical methods estimate ET based on the meteorological
            parameters and energy fluxes. Using these methods, ET can be
            determined by energy balance or mass (water) balance approach. Under
            this project these two approaches are implemented and products are
            being disseminated through NHP portal.{" "}
          </p>
          <p align="justify">
            The energy balance principle is based on net exchange of energy,
            which is constant between earth and atmosphere.ET can be calculated
            as a residual of the surface energy (Rn), sensible heat flux and
            soil heat flux.
          </p>
          <p>
            λE=R_n-G-H Where λE is the latent heat flux, Rnis the net radiation,
            G is the soil heat flux and H is the sensible heat flux, expressed
            in W/m2.
          </p>
          <p align="justify">
            Energy balance based AET product is estimated from mentioned surface
            energy balance algorithm equation. Satellite remote sensing is
            promising tool which has been used to provide reasonable estimate of
            ET under the assumption that energy storage by the canopy is
            negligible. Components of surface energy balance equation are
            derived using satellite remote sensing data and meteorological
            datasets. Estimated surface energy balance components from input
            data are used in Modified Priestley Taylor (PT) algorithm (Ai &amp;
            Yang, 2016; Priestley &amp; Taylor, 1972; Parlange &amp; Katul,
            1992) to estimate daily actual evapotranspiration product.
          </p>
          <p align="justify">
            ET product derived at 3’ x 3’ spatial resolution at a daily time
            interval over the entire Indian subcontinent. The input data sets
            used in this approach can be categorized as meteorological data sets
            and satellite data sets. Inputs from 3 different satellite platform
            (INSAT-3D, Suomi-NPP and Cartosat-1)and two metrological data sets
            (air temperature and dew point temperature) are used to estimate the
            daily AET product. Latent heat flux (λE) is estimated for the Indian
            region form Equation 1for clear sky condition and equivalent
            evaporation amount in mm/day is estimated for the instantaneous
            satellite time pass. Estimated flux value is integrated to daily
            estimate of AET in mm/day for day length over the spatial domain.
            End product i.e. daily AET product estimated from mentioned approach
            is given for dissemination to the end user. Due to different lag
            time associated with input data sets, AET product based on energy
            balance estimate is available with 3 day lag time.
          </p>
          <p align="justify">
            References
            <ol>
              <li>
                Ai, Zhipin, and Yonghui Yang. "Modification and Validation of
                Priestley–Taylor Model for Estimating Cotton Evapotranspiration
                under Plastic Mulch Condition." Journal of Hydrometeorology
                (American Meteorological Society) 17, no. 4 (April 2016):
                1281–1293.
              </li>

              <li>
                Ali, Z., and Y. Yang. "Modification and Validation of
                Priestley–Taylor Model for Estimating Cotton Evapotranspiration
                under Plastic Mulch Condition." Journal of Hydrometeorology,
                2016.
              </li>
              <li>
                Parlange, Marc B., and Gabriel G. Katul. "Estimation of the
                diurnal variation of potential evaporation from a wet bare soil
                surface." Journal of Hydrology 132, no. 1-4 (March 1992): 71-89.
              </li>
              <li>
                Priestley, C. H. B., and R. J. Taylor. "On the Assessment of
                Surface Heat Flux and Evaporation Using Large-Scale Parameters."
                Monthly Weather Review 100, no. 2 (February 1972): 81-92.
              </li>
            </ol>
          </p>
        </div>
      </div>
    );
  }
}
